<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col">
                <input type="date" class="input " v-model="start_date" :disabled="this.orders_loading==true"/>
                
              </div>
              <div class=" col ml-2" >
                <input type="date" class="input " v-model="end_date" :disabled="this.orders_loading==true"/>
                
              </div>

              <div class="col ml-2">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total  Orders</td>
                        <td>{{ filteredOrders.length }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>

                <div class="col ml-2">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total  garments</td>
                        <td>{{ totalGarments }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>

            </div>
      </div>
        
      </div>

      <p class="content">
        This screen displays all orders matching the following criteria :<br />
        <ul>
          <li>Garment name is either Personalised Gaelic Jersey, Club GAA Jersey, Club LGFA Jersey, Club Camogie Jersey, Club Training Jersey (Gaelic), County Team Jersey, County Replica Jersey, County Training Jersey</li>
          
        </ul>
        
        </p>
    
   <div class="notification is-warning" v-if="orders_loading===true">
    Loading ...
  </div>

  <div class="notification is-warning" v-if="orders_loading===false && filteredOrders.length ==0">
    No orders found ...
  </div>

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="orders_loading===false && filteredOrders.length > 0 ">
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Order Date</th>
        <th>Delivery Date</th>
        <th>Customer</th>
        <th>Garment</th>
        <th>Design</th>
          <th>Quantity</th>
          <th>Makeup</th>
        <th>Completed Status</th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
          <td >{{order.ponumber}}</td>
          <td >{{order.orderdate}}</td>
          <td >{{order.deliverydate}}</td>
           <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
           <td>{{order.designname}}</td>
          
           <td>{{ order.total_qty }}</td>
        <td>{{ order.makeup_location_name}}</td>
        <td>{{ order.completed_status}}</td>
			</tr>
      </tbody>
      
    </table>

    <button @click="exportXLS()" class="button is-info" style="">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'EarlyOrders',
  components: {
   	
  },
  data() {
    return {
     number_days: 7,
       clients: [],
      orders: [],
      users: [],
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     clients_loading:true,
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: '',
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrders()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Orders Made Up Offshore.xlsx')

	 },
   
    async getOrders() {
      this.orders_loading=true;
      OrderService.getGaaJerseyOrders(this.accessToken, this.start_date, this.end_date)
          .then(
            (orders => {
              
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 30);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
    filteredOrders: function () {
      let filteredOrders = [];

       if(this.orders.length > 0)
       {
        filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
            // {
              return 1
            // }
          })

          //filteredOrders = filteredOrders.filter(row => row.turnaround <= this.number_days)
       }
       
         

         return filteredOrders
      
    },
    totalGarments() {
        // Ensure orders is defined and is an array
        if (Array.isArray(this.orders)) {
          return this.orders.reduce((sum, order) => sum + (order.total_qty || 0), 0);
        }
        return 0; // Return 0 if orders is not an array
      }
    
     
  },

 
  mounted() {
    
  },
  watch: {
   
    start_date: function () {
     
      this.getOrders()
    },
    end_date: function () {
     
      this.getOrders()
    },
  }
}



</script>


